import React, { useState, useEffect, useRef } from "react";
import { Wrapper, WrapperDesktop } from "./Final.styled";
import { Row, Col, Button, SuccessNotification, ErrorNotification, Spin, Checkbox } from "components/common";
import { callGetApiWithAuth, callPostApiWithAuth } from "utils/api";
import { useHistory } from "react-router";
import Calendar from "react-calendar";
import moment from "moment/moment";
import SelectTimings from "components/Time/SelectTimings";
import { AiOutlineCalendar } from "react-icons/ai";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { getUser } from "utils/auth";


const Final = ({ prev, formData, setFormData, isSmall }) => {
    const [isloading, setIsLoading] = useState(false);
    const [isSubmitLoadin, setIsSubmitLoading] = useState(false);
    const [showTime, setShowTime] = useState([]);
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [repID, setRepID] = useState("");
    const [isProposal, setProposal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [dataLoadedFirstTime, setDataLoadedFirstTime] = useState(false);
    const [height, setHeight] = useState(0);
    const [user, setUser] = useState({});
    const elementRef = useRef(null);

    let query;
    const history = useHistory();

    const handleCalendarIconClick = () => {
        setIsPopupOpen(!isPopupOpen);
    };


    // const handleDateChange = (value) => {
    //     setSelectedDate(value);
    //     // alert(`Selected Date: ${value}`);
    //     setIsPopupOpen(false);
    //   };

    const SuccessRepCall = (data) => {
        setIsLoading(false);
        setRepID(data);
    };

    const FailRepCall = (err) => {
        console.log(err);
    };

    const SuccessCall = (data) => {
        setIsLoading(false);
        setshowTimeSpan(true);
        console.log(data)
        setShowTime(data);
    };

    const FailCall = () => {
        setshowTimeSpan(true);
        setIsLoading(false);
    };

    const handleDateChange = (value) => {
        setshowTimeSpan(false);
        setSelectedDate(value);
        setDate(value)
        setIsLoading(true);
        const params = {};
        params.date = new Date(value).toDateString();

        query = Object.keys(params)
            .map((k) => k + "=" + params[k])
            .join("&");
        callGetApiWithAuth("/leads/get/appointment/date?" + query, SuccessCall, FailCall);
        setDataLoadedFirstTime(true)
        setIsPopupOpen(false);
    };

    const [selectedTime, setSelectedTime] = useState("");

    const handleTimeChange = (value) => {
        setSelectedTime(value);
        //   alert(`Selected Time: ${value}`);

        setFormData({
            ...formData,
            appointmentTime: `${date} ${moment(value, "hh:mm A")
                .add(4, "hours")
                .format("hh:mm A")}`,
            forceSend: isProposal,
        });
    };

    const onSubmit = () => {
        const payload = {
            appointmentTime: formData?.appointmentTime,
            city: formData?.city,
            apptDay: moment(date).format("ddd MMM DD YYYY"),
            apptTime: time,
            email: formData?.email,
            first_name: formData?.firstName,
            last_name: formData?.lastName,
            notes: formData?.notes,
            phone: formData?.phone,
            state: formData?.state,
            street: formData?.street,
            file: formData?.utilPic,
            zip: formData?.zip,
            averageMonthlyBill: formData?.averageMonthlyBill,
            yearlyUsage: formData?.yearlyUsage,
            forceSend: isProposal,
            lat: formData?.lat,
            lng: formData?.lng,
            utility_company: formData?.utility_company,
            utility_id: formData?.utility_id,
            company_id: formData?.company_id,
            jan: formData?.jan,
            feb: formData?.feb,
            mar: formData?.mar,
            apr: formData?.apr,
            may: formData?.may,
            jun: formData?.jun,
            jul: formData?.jul,
            aug: formData?.aug,
            sep: formData?.sep,
            oct: formData?.oct,
            nov: formData?.nov,
            dec: formData?.dec,
        };

        setIsSubmitLoading(true);

        const momentApptTime = moment(payload?.apptTime, "hh:mm A");

        // Subtract 4 hours from the momentApptTime
        const subtractedApptTime = momentApptTime.add(4, "hours");

        // Get the resulting apptTime in the desired format
        const resultingApptTime = subtractedApptTime.format("hh:mm A");

        payload.apptTime = resultingApptTime;

        callPostApiWithAuth("/leads", payload, SuccessAddLeadCall, FailAddLeadCall);
    };


    const SuccessAddLeadCall = () => {
        setIsSubmitLoading(false);
        setTime('');
        SuccessNotification("Customer Added");
        history.push("/leads?offset=0&limit=10");
    };

    const FailAddLeadCall = () => {
        setIsSubmitLoading(false);
        ErrorNotification("Customer Added Failed");
    };

    const [showTimeSpan, setshowTimeSpan] = useState(false);
    // const [selectedDate, setSelectedDate] = useState(null);

    const handleSelectDate = (date) => {
        setSelectedDate(date);
    };

    const renderDateCards = () => {
        const currentDate = new Date();
        const dateCards = [];

        for (let i = 0; i < 15; i++) {
            const cardDate = new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate() + i
            );
            const day = cardDate.toLocaleDateString("en-US", { weekday: "short" });
            const date = cardDate.getDate();
            const isSelected =
                selectedDate && cardDate.toDateString() === selectedDate.toDateString();

            dateCards.push(
                <div
                    key={i}
                    className={`date-card ${isSelected ? "selected" : ""}`}
                    onClick={() => handleDateChange(cardDate)}
                >
                    <div className="day">{day}</div>
                    <div className="date">{date}</div>
                </div>
            );
        }

        return dateCards;
    };



    const smoothScroll = (container, scrollDirection) => {
        if (scrollDirection === 'right') {
            container.scrollLeft += 100;
        }
        else {
            container.scrollLeft -= 100;
        }
    }

    const currentMonthYear = moment().format("MMMM YYYY");

    useEffect(() => {
        setUser(getUser())
        setHeight(elementRef.current.clientHeight);
    }, []);

    return (
        <Wrapper ref={elementRef} isSmall={isSmall}>
            <div className="background-container" style={{ height: height + window.innerHeight }}></div>
            <div className="heading">Pick a Date</div>
            <div className="background-date-container">

                <div className="top-icons">
                    <div className="currentMonth_Div">{currentMonthYear}</div>
                    <AiOutlineCalendar size={isSmall ? 25 : 30} color="white" className="HandlerIcon" onClick={handleCalendarIconClick} />
                </div>


                <div className="date-cards-container" >

                    <button className="styledBtndate" onClick={() => {
                        smoothScroll(document.getElementById('date-container'), 'left')
                    }}>
                        <BiChevronLeft style={{ color: 'black' }} />
                    </button>

                    <div id="date-container" className="renderDataCard">
                        {renderDateCards()}
                    </div>

                    <button className="styledBtndate" onClick={() => {
                        smoothScroll(document.getElementById('date-container'), 'right')
                    }}>
                        <BiChevronRight style={{ color: 'black' }} />
                    </button>
                </div>
            </div>


            {/* <div className="container">
                    <div className="timings-container">{renderTimings()}</div>
                </div> */}



            {isPopupOpen && (
                <div className="popup">
                    <div className="popup-header">
                        <span className="close-icon" onClick={handleCalendarIconClick}>
                            &#x2716;
                        </span>
                    </div>

                    <Row gutter={[20, 20]} style={{ display: "flex", flexDirection: "row", width: "100" }}>
                        <Col lg={20} xs={24} className="main-calendar-data">
                            <Row>
                                <Col span={24} className="Calendar-column">
                                    <Calendar onChange={handleDateChange} value={date} minDate={new Date()}
                                        formatShortWeekday={(locale, value) => {
                                            // Mapping the weekdays to "M T W T F S S"
                                            const weekdays = ["M", "T", "W", "T", "F", "S", "S"];
                                            return weekdays[value.getDay()];
                                        }} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            )}


            {
                dataLoadedFirstTime && showTime?.availableTimeSlots?.length > 0 && !isloading ? (
                    <>
                        <div className="heading">Pick a Time</div>

                        <div className="time-data" >
                            {showTime?.availableTimeSlots?.map((time_) => (
                                <div
                                    className={time === time_ ? "show-time-data-active" : "show-time-data"}
                                    onClick={() => { setTime(time_); handleTimeChange(time_) }}

                                >
                                    {time_}
                                </div>

                            ))}
                        </div>
                    </>
                ) : ((!dataLoadedFirstTime || dataLoadedFirstTime) && isloading) ? (
                    <div className="time-data">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "200px",
                                width: "640px",

                            }}
                        >
                            <Spin spinning={true} />
                        </div>
                    </div>
                ) : (
                    <></>
                )
            }

            {
                dataLoadedFirstTime && showTime?.bookedEvents?.length > 0 && !isloading ? (<>

                    <div className="heading">Appointments</div>

                    {
                        isSmall ? (

                            <div className="appoinment-list-container">
                                {
                                    showTime?.bookedEvents?.map((currElem) => (
                                        <div className="appoinment-Card-List">
                                            <span className="apt-date">
                                                {
                                                    moment(currElem?.start?.dateTime).format('DD/MM/YYYY hh:mm A')
                                                } - {moment(currElem?.end?.dateTime).format('DD/MM/YYYY hh:mm A')}
                                            </span>

                                            {
                                                user.role === 'Setter' ? (
                                                    <span style={{ marginBottom: '1px', color: "Blue" }}>
                                                        {currElem?.organizer.displayName ? currElem?.organizer?.displayName : currElem?.organizer.email}
                                                    </span>
                                                ) : (<></>)
                                            }

                                            <span className="apt-summary">
                                                {
                                                    currElem?.summary
                                                }
                                            </span>


                                        </div>
                                    ))
                                }
                            </div>

                        ) : (<div style={{ display: 'flex', width: '715px', position: 'relative', backgroundColor: 'rgb(58, 150, 184)', marginTop: "20px", borderRadius: '10px' }}>
                            {
                                showTime?.bookedEvents?.length > 2 ? <button className="styledbtn1" onClick={() => {
                                    smoothScroll(document.getElementById('appointment-container'), 'left')
                                }}>
                                    <BiChevronLeft style={{ color: 'black' }} />
                                </button> : <> </>
                            }

                            <div id="appointment-container" className="background-appointment-container">
                                {
                                    showTime?.bookedEvents?.map((val, i) => {

                                        return (<>
                                            <div className="background-appointment-cards">
                                                <p style={{ marginBottom: '1px', marginTop: "12px", padding: "2px" }}>{new Date(val?.start?.dateTime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: 'true' })} - {new Date(val?.end?.dateTime).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: 'true' })} </p>
                                                {
                                                    user.role === 'Setter' ? (
                                                        <p style={{ marginBottom: '1px' }}>
                                                            {val?.organizer.displayName ? val?.organizer.displayName : val?.organizer.email}
                                                        </p>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <p key={i} style={{ color: "Blue" }}>
                                                    {val?.summary}
                                                </p>
                                            </div>
                                        </>)

                                    })
                                }
                            </div>

                            {
                                showTime?.bookedEvents?.length > 2 ? <button className="styledbtn2" onClick={() => {
                                    smoothScroll(document.getElementById('appointment-container'), 'right')
                                }}>
                                    <BiChevronRight style={{ color: 'black' }} />
                                </button> : <></>
                            }

                        </div>)
                    }

                </>) : ((!dataLoadedFirstTime || dataLoadedFirstTime) && isloading) ? (<div style={{ marginTop: '15px' }} className="time-data">
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "80px",
                            width: "640px",

                        }}
                    >
                        <Spin spinning={true} />
                    </div>
                </div>) : (<></>)
            }




            <Col span={24}>
                <Row className="buttons" gutter={[15, 15]}>
                    <Col xs={12} lg={12}>
                        <Button title="Previous" onClick={() => prev()} />
                    </Col>
                    <Col xs={12} lg={12}>
                        <Button loading={isSubmitLoadin} title="Submit" onClick={onSubmit} />
                    </Col>
                    <Col span={24} className="Calendar-column">
                        <Checkbox
                            style={{ color: "white", marginTop: "6px" }}
                            defaultChecked={false}
                            onChange={(e) => {
                                setProposal(e.target.checked);
                            }}
                        >
                            Auto Request Proposal
                        </Checkbox>
                    </Col>
                </Row>
            </Col>


        </Wrapper>

    );

};

export default Final;
